module.exports = __webpack_public_path__ + "img/10.2dd6d881.png";